import { useContext } from 'react'

import { DocumentsModalsContext } from './context'

export function useDocumentsModals() {
  const context = useContext(DocumentsModalsContext)

  if (!context) {
    throw new Error('useDocumentsModals must be used within a DocumentsModalsProvider')
  }

  return context
}
